var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTabActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1002 11.5686V5.44859C20.1002 4.09859 19.5242 3.55859 18.0932 3.55859H14.4572C13.0262 3.55859 12.4502 4.09859 12.4502 5.44859V11.5686C12.4502 12.9186 13.0262 13.4586 14.4572 13.4586H18.0932C19.5242 13.4586 20.1002 12.9186 20.1002 11.5686Z",
    fill: "#0C66E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.65 13.5502V19.6702C10.65 21.0202 10.074 21.5602 8.643 21.5602H5.007C3.576 21.5602 3 21.0202 3 19.6702V13.5502C3 12.2002 3.576 11.6602 5.007 11.6602H8.643C10.074 11.6602 10.65 12.2002 10.65 13.5502Z",
    fill: "#0C66E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1002 19.6678V17.1478C20.1002 15.7978 19.5242 15.2578 18.0932 15.2578H14.4572C13.0262 15.2578 12.4502 15.7978 12.4502 17.1478V19.6678C12.4502 21.0178 13.0262 21.5578 14.4572 21.5578H18.0932C19.5242 21.5578 20.1002 21.0178 20.1002 19.6678Z",
    fill: "#0C66E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.65 7.96859V5.44859C10.65 4.09859 10.074 3.55859 8.643 3.55859H5.007C3.576 3.55859 3 4.09859 3 5.44859V7.96859C3 9.31859 3.576 9.85859 5.007 9.85859H8.643C10.074 9.85859 10.65 9.31859 10.65 7.96859Z",
    fill: "#0C66E4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTabActive);
export default __webpack_public_path__ + "static/media/dashboardTabActive.5d7a596ae25ea9e7cc76e6f116939f18.svg";
export { ForwardRef as ReactComponent };